import React, { useState } from 'react'
import { useSprings, animated, to as interpolate } from '@react-spring/web'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

import styles from '../styles/styles.module.css'



const to = (i) => ({
  x: 0,
  y: i * -4,
  scale: 1,
  rot: 0,
  delay: i * 100,
})

const from = (_i) => ({ x: 0, rot: 0, scale: 1.5, y: -1000 })
const trans = (_r, s) => `perspective(1500px) scale(${s})`

const Deck = ({ cardList  }) => {
  const [gone] = useState(() => new Set()) // Track swiped cards
  const [props, api] = useSprings(cardList.length, (i) => ({
    ...to(i),
    from: from(i),
  }))

  const handleClick = (index) => {
    if (gone.has(index)) return // Ignore if card is already gone

    gone.add(index) // Mark card as swiped
    api.start((i) => {
      if (index !== i) return // Only update the clicked card
      const dir = Math.random() > 0.5 ? 1 : -1
      const x = Math.max(-200, Math.min(200, 200 * dir))
      const scale = 1

      return {
        x,
        scale,
        delay: undefined,
        config: { friction: 50, tension: 200 },
      }
    })

    if (gone.size === cardList.length) {
      // Reset deck when all cards are gone
      setTimeout(() => {
        gone.clear()
        api.start((i) => to(i))
      }, 600)
    }
  }

  return (
    <div className={styles.container}>
      {props.map(({ x, y, scale }, i) => (
        <animated.div className={styles.deck} key={i} style={{ x, y }}>
          <animated.div
            onClick={() => handleClick(i)}
            style={{
              transform: interpolate([scale], trans),
            }}
          >
            <LazyLoadImage
              effect="blur" // Adds a blur effect while loading
              src={cardList[i]}
              className={styles.cardImage}
            />
          </animated.div>
        </animated.div>
      ))}
    </div>
  )
}

export default Deck
